export default {
  running: {
    name: 'Бег',
    icon: 'running',
  },
  walking: {
    name: 'Ходьба',
    icon: 'walking',
  },
  cycling: {
    name: 'Велозаезд',
    icon: 'cycling',
  },
  skiing: {
    name: 'Лыжи',
    icon: 'skiing',
  },
  swimming: {
    name: 'Плавание',
    icon: 'swimming',
  },
};
